import { useState } from "preact/hooks";
import { ACCENTS } from "../demo-v2/accents.js";
import { demoHref } from "../demo-v2/prefill.js";
import type { AccentId } from "../demo-v2/types.js";
import { BrandScene } from "./brand-scene.js";
import type { FlowCopy, WallCopy } from "./content.js";
import { MenuIcon } from "./icons.js";
import type { LaunchCopy } from "./planner-content.js";

export interface LaunchProps {
  readonly copy: LaunchCopy;
  readonly flow: FlowCopy;
  readonly wall: WallCopy;
}

export function Launch({ copy, flow, wall }: LaunchProps) {
  const [name, setName] = useState("");
  const [accent, setAccent] = useState<AccentId>("green");
  const shown = name.trim() || copy.placeholder;
  return (
    <section class="section studio launch" id="teste">
      <div class="wrap studio-grid">
        <div class="studio-text">
          <p class="micro">{copy.label}</p>
          <h2 class="section-title serif">{copy.title}</h2>
          <p class="split-body">{copy.body}</p>
        </div>
        <div class="studio-controls">
          <label class="launch-field">
            <span class="micro">{copy.nameLabel}</span>
            <input
              class="launch-input"
              value={name}
              maxLength={40}
              placeholder={copy.placeholder}
              autocomplete="organization"
              onInput={(event) => setName((event.currentTarget as HTMLInputElement).value)}
            />
          </label>
          <p class="micro" id="launch-color">
            {copy.colorLabel}
          </p>
          <div class="studio-colors" role="group" aria-labelledby="launch-color">
            {ACCENTS.map((option) => (
              <button
                key={option.id}
                type="button"
                class={option.id === accent ? "swatch is-on" : "swatch"}
                style={{ "--swatch": option.hex }}
                aria-label={option.label}
                aria-pressed={option.id === accent}
                onClick={() => setAccent(option.id)}
              />
            ))}
            <span class="studio-color-name">
              {ACCENTS.find((option) => option.id === accent)?.label}
            </span>
          </div>
        </div>
        <div class="launch-actions">
          <a
            class="pill pill-ink launch-cta"
            href={demoHref(name, accent)}
            data-testid="launch-cta"
          >
            {copy.cta}
            <MenuIcon name="arrow" size={16} />
          </a>
          <p class="launch-note">{copy.note}</p>
          <div class="launch-qr">
            <img src="/assets/demo/qr.svg" alt="" width={88} height={88} loading="lazy" />
            <div>
              <strong>{copy.qrTitle}</strong>
              <span>{copy.qrBody}</span>
            </div>
          </div>
        </div>
        <BrandScene name={shown} accent={accent} flow={flow} wall={wall} />
      </div>
    </section>
  );
}
